import { render, staticRenderFns } from "./bottomNavV.vue?vue&type=template&id=39c585bf&scoped=true&"
import script from "./bottomNavV.vue?vue&type=script&lang=js&"
export * from "./bottomNavV.vue?vue&type=script&lang=js&"
import style0 from "./bottomNavV.vue?vue&type=style&index=0&id=39c585bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c585bf",
  null
  
)

export default component.exports